export const API_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://dexa-contas.com' : 'http://localhost:8080'